import { useQuery } from '@tanstack/react-query';
import { versionApi } from '@api/versionApi';

export function useServerVersion() {
  return useQuery({
    queryKey: ['server-version'],
    queryFn: versionApi.get,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
